// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"323255fb","453":"44b14fea","455":"1323df5d","977":"faf20cb7"}[chunkId] + ".chunk.js";
};